import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";

const ModalQR = ({ modalOpen, setModalOpen, qrCode, selectedDeviceId, getData }) => {
  const [ready, setReady] = useState(false);
  const [deviceId, setDeviceId] = useState(selectedDeviceId || "");
  const [qr, setQr] = useState(qrCode);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const socketUrl = process.env.REACT_APP_SOCKET_IO_URL || "http://localhost:4000";

  useEffect(() => {
    setDeviceId(selectedDeviceId || "");
  }, [selectedDeviceId]);

  useEffect(() => {
    setQr(qrCode);
    if (qrCode) {
      setLoading(false);
    }
  }, [qrCode]);

  useEffect(() => {
    const newSocket = io(socketUrl, {
      transports: ["websocket", "polling"],
      reconnection: true
    });

    newSocket.on("connect", () => {
      console.log("📡 Socket.IO connected to backend:", newSocket.id);
    });

    newSocket.on("wa_qr", (data) => {
      const targetUserId = data.user_id;
      const targetDeviceId = data.deviceId || data.device_id;
      
      console.log(`📲 Baileys QR Code received for user ${targetUserId}, device ${targetDeviceId}`);

      if (!user.id || String(user.id) === String(targetUserId)) {
        if (!selectedDeviceId || selectedDeviceId === targetDeviceId) {
          setDeviceId(targetDeviceId);
          setQr(data.qr);
          setReady(false);
          setLoading(false);
        }
      }
    });

    newSocket.on("wa_authenticated", (data) => {
      const targetUserId = data.user_id;
      const targetDeviceId = data.deviceId || data.device_id;

      if (!user.id || String(user.id) === String(targetUserId)) {
        console.log(`🔐 Device ${targetDeviceId} authenticated!`);
      }
    });

    newSocket.on("wa_ready", (data) => {
      const targetUserId = data.user_id;
      const targetDeviceId = data.deviceId || data.device_id;

      if (!user.id || String(user.id) === String(targetUserId)) {
        console.log(`✅ Device ${targetDeviceId} is ready & connected!`);
        setReady(true);
        setQr(null);
        toast.success(`WhatsApp Device (${targetDeviceId}) berhasil terhubung!`);
        
        const closeBtn = document.getElementById("closeModalQr");
        if (closeBtn) closeBtn.click();
        if (getData) getData();
      }
    });

    newSocket.on("wa_disconnect", (data) => {
      const targetUserId = data.user_id;
      const targetDeviceId = data.deviceId || data.device_id;

      if (!user.id || String(user.id) === String(targetUserId)) {
        console.log(`⚠️ Device ${targetDeviceId} disconnected!`);
        setReady(false);
        setQr(null);
        toast.warning(`WhatsApp Device (${targetDeviceId}) terputus.`);
        if (getData) getData();
      }
    });

    return () => {
      newSocket.disconnect();
    };
  }, [user.id, selectedDeviceId, getData, socketUrl]);

  const handleClose = () => {
    if (setModalOpen) setModalOpen(false);
    setReady(false);
    setQr(null);
  };

  return (
    <div
      className="modal fade"
      id="connectDeviceModal"
      tabIndex="-1"
      aria-labelledby="connectDeviceModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content radius-12 border-0 shadow-lg">
          <div className="modal-header bg-primary-50 py-16 px-24 border-bottom">
            <h5 className="modal-title text-primary-600 d-flex align-items-center gap-2" id="connectDeviceModalLabel">
              <Icon icon="logos:whatsapp-icon" className="text-2xl" /> Hubungkan WhatsApp Bot (Baileys)
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-24 text-center">
            <div className="alert alert-info py-8 px-16 radius-8 mb-20 text-start text-xs">
              <strong>Petunjuk:</strong>
              <ol className="mb-0 ps-16 mt-4">
                <li>Buka aplikasi WhatsApp di HP Anda</li>
                <li>Pilih <strong>Menu (titik 3)</strong> atau <strong>Pengaturan</strong> &gt; <strong>Perangkat Tertaut (Linked Devices)</strong></li>
                <li>Pilih <strong>Tautkan Perangkat</strong> dan scan QR Code di bawah ini</li>
              </ol>
            </div>

            <div className="qr-container p-16 border radius-12 bg-light d-inline-block shadow-sm">
              {ready ? (
                <div className="text-center py-24">
                  <Icon icon="mdi:check-circle" className="text-success text-6xl mb-12" />
                  <h6 className="text-success mb-4">Perangkat Berhasil Terhubung!</h6>
                  <p className="text-muted text-sm mb-0">Device ID: {deviceId}</p>
                </div>
              ) : qr ? (
                <div className="text-center">
                  <p className="text-sm font-semibold text-secondary-light mb-12">
                    Device ID: <span className="badge bg-primary-100 text-primary-700">{deviceId || "Device"}</span>
                  </p>
                  <div className="p-8 bg-white radius-8 d-inline-block border">
                    <QRCodeSVG value={qr} size={240} level="M" />
                  </div>
                  <p className="text-xs text-muted mt-12 mb-0">
                    <Icon icon="mdi:refresh" className="me-4" /> QR Code berganti otomatis secara berkala
                  </p>
                </div>
              ) : (
                <div className="text-center py-32 px-24">
                  <div className="spinner-border text-primary mb-16" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-muted text-sm mb-0">Menyiapkan QR Code dari Baileys Server...</p>
                  <p className="text-xs text-secondary-light mt-4">Mohon tunggu beberapa detik.</p>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer border-top py-12 px-24 bg-light">
            <button
              type="button"
              className="btn btn-secondary px-20"
              id="closeModalQr"
              onClick={handleClose}
              data-bs-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalQR;
